export default "__VITE_ASSET__BrSiXiH$__"